<!-- Bottone circolare (si vede solo se chat chiusa) -->
<ng-container *ngIf="environment['projectName']">
  <button *ngIf="!chatOpen"
          class="btn btn-primary rounded-circle shadow chat-btn"
          (click)="toggleChat()">
    <i class="fa-regular fa-comment"></i>
  </button>

  <!-- Finestra chat -->
  <div class="card shadow chat-window"
       [class.open]="chatOpen"
       [class.closed]="!chatOpen">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      FortyBot
      <button type="button" class="close text-white" (click)="closeChat()">&times;</button>
    </div>

    <div class="card-body chat-body">
      <!-- Messaggi -->
      <div *ngFor="let msg of messageList" class="d-flex mb-2"
           [ngClass]="{'justify-content-end': msg.sender === 'user',
                     'justify-content-start': msg.sender === 'bot'}">

        <div class="p-2 rounded shadow-sm msg-bubble"
             [ngClass]="{
             'bg-primary text-white user-bubble': msg.sender === 'user',
             'bg-light text-dark bot-bubble': msg.sender === 'bot'
           }">
          <p [innerHTML]="formatMessage(msg.message)"></p>
        </div>
      </div>

      <!-- Animazione puntini quando il bot sta rispondendo -->
      <div *ngIf="isLoading" class="d-flex mb-2 justify-content-start">
        <div class="p-2 rounded shadow-sm bg-light text-dark bot-bubble">
        <span class="typing-dots">
          <span></span><span></span><span></span>
        </span>
        </div>
      </div>

      <!-- Anchor per autoscroll -->
      <div #scrollAnchor></div>
    </div>

    <div class="card-footer">
      <div class="input-group">
        <input type="text"
               class="form-control"
               [(ngModel)]="newMessage"
               placeholder="Scrivi un messaggio..."
               (keyup.enter)="sendMessage()">

        <div class="input-group-append">
          <button class="btn btn-primary"
                  type="button"
                  (click)="sendMessage()"
                  [disabled]="isLoading">
            <i class="fas fa-paper-plane"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

</ng-container>
